import { Text } from '$components'
import { LinkButton } from '$components'
import { Tooltip } from '$components'
import { SmileIcon, PlusIcon } from '$components'
import { ClientRoutePath } from '../routes/protected'
import { useTenant } from '$features/auth/hooks/use-tenant'
import { SUBSCRIPTION_EXPIRED_MESSAGE } from '$constants/subscription'

export type NoClientsEmptyStateProps = {
  isNoResults: boolean
}

export function NoClientsEmptyState({ isNoResults = false }: NoClientsEmptyStateProps) {
  const { hasSubscriptionExpired } = useTenant()

  return (
    <div className="w-full h-fit p-12 bg-neutral-50 rounded-3xl flex flex-col items-center justify-center text-center">
      <SmileIcon className="size-12 text-indigo-500 mb-4" />

      <Text
        type="h3"
        className="mb-4 text-gray-900"
      >
        {!isNoResults ? 'No clients created yet' : 'No clients found'}
      </Text>

      <Text
        type="s"
        className="text-gray-600 max-w-md mb-6"
      >
        {!isNoResults
          ? 'Clients are the pet owners who book appointments with you. Add your first client to start managing their pets and booking appointments.'
          : 'No clients found matching your search. Try adjusting your search criteria or create a new client.'
        }
      </Text>

      {isNoResults && (
        <Tooltip
          content={hasSubscriptionExpired ? SUBSCRIPTION_EXPIRED_MESSAGE : undefined}
          disabled={!hasSubscriptionExpired}
        >
          <LinkButton
            to={ClientRoutePath.ClientsCreate}
            icon={PlusIcon}
            disabled={hasSubscriptionExpired}
          >
            New Client
          </LinkButton>
        </Tooltip>
      )}
    </div>
  )
}
